var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4341 0.795027C32.4941 1.85506 32.4941 3.57372 31.4341 4.63376L12.8629 23.205C11.8029 24.265 10.0843 24.265 9.02422 23.205L0.795082 14.9764C-0.264985 13.9164 -0.265033 12.1977 0.794973 11.1376C1.85498 10.0776 3.57364 10.0775 4.63371 11.1375L10.9435 17.4469L27.5954 0.795027C28.6554 -0.265009 30.3741 -0.265009 31.4341 0.795027Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRounded);
export default __webpack_public_path__ + "static/media/check_rounded.7252d54ada62c028ebba7dd1d827cdb7.svg";
export { ForwardRef as ReactComponent };